import getComponentName from './getComponentName';
import setComponentName from './setComponentName';
function setHOCDisplayName(Component, WrappedComponent, name) {
  setComponentName(Component, "".concat(name, "(").concat(getComponentName(WrappedComponent), ")"));
}
export default setHOCDisplayName;